import { Button, Card, Modal, Skeleton } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import { useContext, useState } from 'react';
import { groupBy } from 'lodash';
import ErrorMessage from '../../ErrorMessage';
import { useUiData } from '../../../lib/hooks';
import CTX from '../../../lib/AssignmentsContext';
import TasksTree from '../TasksTree';
import EntityPicker, { EntityList } from '../EntityPicker';
const modalWidth = 1024 + 100 + 24 * 2;
const uiKeys = ['ageGroups', 'grades'];
const PlaylistWizard = () => {
  const {
    isPending,
    isError,
    data: uiData
  } = useUiData(uiKeys);
  const {
    data,
    actions,
    status
  } = useContext(CTX);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const {
    submit,
    reset
  } = actions;
  const assignmentsNumber = data.assignments.length;
  const tasksNumber = data.assignments.map(a => a.data.tasks.length).reduce((s, v) => s + v, 0);
  const almostReady = assignmentsNumber > 0 && data.assignments.every(({
    data
  }) => Object.values(data).every(Boolean));
  const readyPlaylist = almostReady && data.entities.length > 0 && (!['District', 'School'].includes(data.entities[0].__typename) || [data.grades, data.ages].some(d => d.length > 0));
  const tasksCount = data.assignments.map(({
    data
  }) => data.tasks.length).reduce((acc, val) => acc + val, 0);
  const modal = <Modal title={<>
					New Assignment: {data.label} {' '}
					<span className="helper-text">({tasksCount} activities)</span>
				</>} open closable destroyOnClose footer={[<Button key="assign" type="primary" size="large" style={{
    minWidth: 200
  }} icon={<AuditOutlined />} disabled={!readyPlaylist} onClick={() => setShowConfirm(true)}>
					Assign
				</Button>]} width={modalWidth} onCancel={() => {
    actions.setListPrepared(false);
    data.klass = null;
    data.studentIDs = [];
  }}>
			<EntityPicker />
		</Modal>;
  const confirm = <Modal title="Confirm Assignment" open closable={false} destroyOnClose width={modalWidth} footer={<Button type="primary" size="large" icon={<AuditOutlined />} style={{
    width: '100%'
  }} onClick={() => {
    setShowConfirm(false);
    submit();
  }}>
					Confirm Assignment
				</Button>}>
			<Card bordered={false} extra={<Button type="link" onClick={() => setShowConfirm(false)}>
						MODIFY
					</Button>} title={<>
						{`Your Assignments `}
						<aside style={{
        display: 'inline-block',
        color: '#DCDCDC'
      }}>
							{`(${assignmentsNumber} Assignment${assignmentsNumber === 1 ? '' : 's'}, ${tasksNumber} ${tasksNumber === 1 ? 'Activity' : 'Activities'})`}
						</aside>
					</>}>
				<TasksTree />
			</Card>
			<Card bordered={false} extra={<Button type="link" onClick={() => setShowConfirm(false)}>
						MODIFY
					</Button>} title={<>
						{`Your Selected Entities `}
						<aside style={{
        display: 'inline-block',
        color: '#DCDCDC'
      }}>
							{`(${Object.entries(groupBy(data.entities, '__typename')).map(([k, v]) => `${v.length} ${v.length === 1 ? k : k + (k.endsWith('s') ? 'es' : 's')}`).join(', ')})`}
						</aside>
					</>}>
				{data.ages.length > 0 && `Age Groups: ${uiData.ageGroups.filter(e => data.ages.includes(e.id)).map(e => e.name).join(', ')}`}
				{data.grades.length > 0 && `Grade Levels: ${uiData.grades.filter(e => data.grades.includes(e.id)).map(e => e.name).join(', ')}`}
				<EntityList />
			</Card>
		</Modal>;
  if (isPending) {
    return <Skeleton />;
  }
  if (isError) {
    return <ErrorMessage message="There was an error during loading app data. Reload the page to try again." />;
  }
  return <>
			{status.listPrepared && (showConfirm ? confirm : modal)}
		</>;
};
export default PlaylistWizard;